import { render, staticRenderFns } from "./XkzbhhcDetail.vue?vue&type=template&id=13a6774a&scoped=true&"
import script from "./XkzbhhcDetail.vue?vue&type=script&lang=js&"
export * from "./XkzbhhcDetail.vue?vue&type=script&lang=js&"
import style0 from "./XkzbhhcDetail.vue?vue&type=style&index=0&id=13a6774a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a6774a",
  null
  
)

export default component.exports